import { render } from "./AboutService.vue?vue&type=template&id=6a10adc0"
import script from "./AboutService.vue?vue&type=script&lang=js"
export * from "./AboutService.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AboutService.vue?vue&type=style&index=0&id=6a10adc0&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__